<script>
export default {
  name: "auctions-overview",
  props: {},
  data: function() {
    return {
      unstarted: null,
      inProgress: null,
      complete: null,
    };
  },
  methods: {
    async getAuctionsSummary() {
      var summary = await this.$store.dispatch("getRequest", { controller: "Auction", method: "Overview" });
      this.unstarted = summary.unstarted;
      this.inProgress = summary.inProgress;
      this.complete = summary.complete;
    },
  },
  computed: {
    isMobile: function() {
      return this.$store.state.isMobile;
    },
  },
  mounted() {
    this.getAuctionsSummary();
  },
};
</script>
<template>
  <div class="row" style="text-align:center;margin-bottom:1rem;" :class="[isMobile ? 'mobile' : '']">
    <div class="col-4">
      <span class="auction-qty status-unstarted">{{ unstarted }} </span>
      <span class="auction-status">Unstarted </span>
    </div>
    <div class="col-4">
      <span class="auction-qty status-in-progress">{{ inProgress }} </span>
      <span class="auction-status">In Progress </span>
    </div>
    <div class="col-4">
      <span class="auction-qty status-complete">{{ complete }} </span>
      <span class="auction-status">Complete </span>
    </div>
  </div>
</template>
<style scoped>
.auction-qty {
  font-size: 56px;
  border-width: 4px !important;
  border-style: solid !important;
  height: 100px;
  width: 100px;
  display: block;
  text-align: center;
  margin: auto;
  border-radius: 999px;
  line-height: 75px;
}
.auction-qty.status-unstarted {
  border-color: red;
}
.auction-qty.status-in-progress {
  border-color: orange;
}
.auction-qty.status-complete {
  border-color: gray !important;
  color: gray !important;
}
.mobile {
  margin-top: 1rem;
}
.mobile .auction-qty {
  height: 50px;
  width: 50px;
  line-height: 30px;
  font-size: 24px;
}
[class*="status"] {
  background-color: unset;
  border-width: 4px;
  border-radius: 999px;
}
</style>
